
import config from "../firebase/config.json";

export const usernameSearch = async (username: string) => {
  const res = await fetch(`https://${getEnv()}search.smokeless.world/search/${username}`)
  
  return await res.json()
 
};

export const duplicateSearch = async (username: string) => {
  const res = await fetch(`https://${getEnv()}search.smokeless.world/duplicate/${username}`)
  
  return await res.json()
   
};

const getEnv = () => {
  let env = "";
  switch (config.projectId) {
    case "smokeless-world-develop":
      env = "dev.";
      break;
    case "smokeless-world-stage":
      env = "stage.";
      break;
    default:
      env = "";
      break;
  }
  return env;
};



// WEBPACK FOOTER //
// ./src/functions/searchApis.ts